const statuses = [
  'PENDING',
  'INPROGRESS',
  'COMPLETED',
  'RESERVED',
  'ADMINCANCELLED',
  'USERCANCELLED',
  'REJECTED',
  'NOSHOW',
];

export { statuses };
